export default
`Beste {naam}

Er is een account voor je aangemaakt, om gebruik te maken van je account dien je eerst een wachtwoord aan te maken, klik hiervoor op onderstaande knop.

Met vriendelijke groet,
{bedrijfsnaam}`
